export default {
  multiselect: true,
  checkbox: true,
};
